export const isLocal = () => {
	if (!window) return false;
	return window?.location?.href?.includes('localhost') ?? false;
};
